import React, { useRef, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import { useInvokeDenaliAssistant } from '../../../../api/denaliAssistant'
import MessageInput from '../common/MessageInput'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import Background from '../../../../providers/BackgroundProvider/Background'
import Greetings from './Greetings'
import SuggestionList from './SuggestionList'
import Notification from './ReadingListNotification'

const useStyles = makeStyles((theme) => ({
  landingContainer: {
    position: 'relative',
    maxWidth: '1000px',
    minWidth: '640px',
    height: '100%',
    margin: '0 auto',
    padding: '0 var(--padding-md)'
  }
}))

function LandingPage () {
  const classes = useStyles()
  const history = useHistory()
  const messageInputRef = useRef(null)

  // Mutations
  const invokeMutation = useInvokeDenaliAssistant()

  const handleSendMessage = useCallback(async (message) => {
    if (!message.trim()) return

    try {
      // Send the message - thread will be created automatically if needed
      const result = await invokeMutation.mutateAsync({
        prompt: message,
        context: {
          currentView: 'ai-assistant-chat'
        },
        options: {
          modelStrategy: 'balanced',
          streamResponse: true,
          includeTrailOfThought: true
        }
      })

      // If this was a new thread, update URL to the new thread
      if (result.threadId) {
        history.replace(`/denali-ai/chat/${result.threadId}`)
      }
    } catch (error) {
      console.error('Failed to send message:', error)
      // TODO: Show error toast
    }
  }, [invokeMutation, history])

  return (
    <Background
      // light='center / cover no-repeat url(https://resources.swsapp.com/100/images/purpleMountains.webp)'
      light='var(--dai-bg)'
      dark='var(--dai-bg)'
    >
      <div className={classes.landingContainer}>
        <FlexColumn className='justify-center items-center' style={{ width: '100%', height: 'calc(100% - 15vh)', gap: '48px' }}>
          <FadeIn className='w-full'>
            <Greetings />
          </FadeIn>
          <FadeIn delay={0.1} className='w-full mb-5'>
            <MessageInput
              ref={messageInputRef}
              onSend={handleSendMessage}
              placeholder='What do you want to know?'
              minRows={4}
            />
          </FadeIn>
          <FadeIn delay={1} duration={1}>
            <SuggestionList
              onSuggestionClick={(prompt) => {
              // Set the suggestion in the input so user can review/modify before sending
                messageInputRef.current?.setValue(prompt)
              }}
            />
          </FadeIn>
        </FlexColumn>
        <Notification />
      </div>
    </Background>
  )
}

export default LandingPage
